import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppins } from '../../../Components/Typo';
import { Counter } from '../../../Components/Motion';

// `icon` is a lucide icon component (e.g. CalendarCheck) rendered in a tinted
// badge. Falls back gracefully to nothing when omitted.
const Card = ({ label, count, icon: Icon, sx, ...rest }) => (
  <Stack
    bgcolor={COLORS.surface}
    border={`1px solid ${COLORS.hairline}`}
    justifyContent='space-between'
    borderRadius={3}
    p={3}
    gap={2.5}
    sx={{
      transition: 'transform .2s ease, box-shadow .2s ease, border-color .2s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        borderColor: COLORS.teal,
        boxShadow: '0 14px 30px rgba(14, 27, 31, 0.10)',
      },
      ...sx,
    }}
    {...rest}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='flex-start' gap={2}>
      <TypoPoppins variant='body1' color={COLORS.inkSoft} fontWeight={500}>
        {label}
      </TypoPoppins>
      {Icon && (
        <Box
          sx={{
            width: 46,
            height: 46,
            flexShrink: 0,
            borderRadius: 2.5,
            bgcolor: COLORS.tealSoft,
            color: COLORS.teal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon size={22} strokeWidth={1.8} />
        </Box>
      )}
    </Stack>
    <Typography variant='h2' color={COLORS.teal} lineHeight={1}>
      {typeof count === 'number' ? <Counter value={count} duration={1.2} /> : count ?? '—'}
    </Typography>
  </Stack>
);

Card.propTypes = {
  label: PropTypes.node,
  count: PropTypes.any,
  icon: PropTypes.elementType,
  sx: PropTypes.object,
};

export default React.memo(Card);
